<template>
  <a-card :bordered="false">
    <a-row :gutter="24">
      <a-col :span="24">
        <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                <a-form-item label="员工姓名">
                  <a-input
                    v-model:value="queryParam.nickName"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>
              <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                <a-form-item label="岗位名称">
                  <a-input
                    v-model:value="queryParam.postName"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>
              <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                <a-form-item label="员工角色">
                  <a-select
                    v-model:value="queryParam.roleId"
                    placeholder="请选择"
                    style="width: 100%"
                    allow-clear
                    show-search
                    :filter-option="filterRoleOption"
                    class="no-border-radius-select"
                  >
                    <a-select-option v-for="role in roleOptions" :key="role.id" :value="role.id">
                      {{ role.roleName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <!-- 按钮区域：默认在第一行，展开后在最后一行 -->
              <a-col v-if="!advanced" :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                <a-form-item>
                  <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                    <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                    <a-button style="margin-left: 8px" @click="resetQuery" class="no-border-button reset-button"
                      >重置</a-button
                    >
                    <a-button style="margin-left: 8px" @click="toggleAdvanced" class="no-border-button toggle-button">
                      {{ advanced ? '收起' : '展开' }}
                      <UpOutlined v-if="advanced" />
                      <DownOutlined v-else />
                    </a-button>
                  </span>
                </a-form-item>
              </a-col>

              <!-- 高级搜索：补充剩余字段 -->
              <template v-if="advanced">
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="民族">
                    <a-input
                      v-model:value="queryParam.nationality"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="所属项目">
                    <a-select
                      v-model:value="queryParam.projectId"
                      placeholder="请选择"
                      style="width: 100%"
                      allow-clear
                      show-search
                      :filter-option="filterProjectOption"
                      class="no-border-radius-select"
                    >
                      <a-select-option v-for="project in projectList" :key="project.id" :value="project.id">
                        {{ project.chineseName || project.projectCode }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="项目授权">
                    <a-select
                      v-model:value="queryParam.projectCodes"
                      placeholder="请选择"
                      style="width: 100%"
                      allow-clear
                      show-search
                      :filter-option="filterProjectOption"
                      class="no-border-radius-select"
                    >
                      <a-select-option value="0">全部项目</a-select-option>
                      <a-select-option v-for="project in projectList" :key="project.id" :value="String(project.id)">
                        {{ project.chineseName || project.projectCode }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="手环MAC">
                    <a-input
                      v-model:value="queryParam.wristbandMac"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="出生年月日">
                    <a-range-picker
                      v-model:value="birthDateRange"
                      style="width: 100%"
                      format="YYYY-MM-DD"
                      value-format="YYYY-MM-DD"
                      :placeholder="['起始日期', '截止日期']"
                      allow-clear
                      class="no-border-radius-picker"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="入职日期">
                    <a-range-picker
                      v-model:value="entryTimeRange"
                      style="width: 100%"
                      format="YYYY-MM-DD"
                      value-format="YYYY-MM-DD"
                      :placeholder="['起始日期', '截止日期']"
                      allow-clear
                      class="no-border-radius-picker"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="离职日期">
                    <a-range-picker
                      v-model:value="departTimeRange"
                      style="width: 100%"
                      format="YYYY-MM-DD"
                      value-format="YYYY-MM-DD"
                      :placeholder="['起始日期', '截止日期']"
                      allow-clear
                      class="no-border-radius-picker"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="当前状态">
                    <a-select
                      v-model:value="queryParam.userStatus"
                      placeholder="请选择"
                      style="width: 100%"
                      allow-clear
                      class="no-border-radius-select"
                    >
                      <a-select-option v-for="(d, index) in dict.type['current_status']" :key="index" :value="d.value">
                        {{ d.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="用户手机号">
                    <a-input
                      v-model:value="queryParam.phoneNumber"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="用户登录名">
                    <a-input
                      v-model:value="queryParam.userName"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="用户授权平台">
                    <a-select
                      v-model:value="queryParam.loginPlatform"
                      placeholder="请选择"
                      style="width: 100%"
                      allow-clear
                      class="no-border-radius-select"
                    >
                      <a-select-option
                        v-for="(d, index) in dict.type['user_authorized_platform']"
                        :key="index"
                        :value="d.value"
                      >
                        {{ d.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item label="状态" prop="status">
                    <a-select
                      v-model:value="queryParam.status"
                      placeholder="请选择状态"
                      style="width: 100%"
                      allow-clear
                      class="no-border-radius-select"
                    >
                      <a-select-option
                        v-for="(d, index) in dict.type['sys_normal_disable']"
                        :key="index"
                        :value="d.value"
                      >
                        {{ d.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <!-- 展开后，按钮在最后一行 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="8" :sm="24" :xs="8">
                  <a-form-item>
                    <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                      <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                      <a-button style="margin-left: 8px" @click="resetQuery" class="no-border-button reset-button"
                        >重置</a-button
                      >
                      <a-button style="margin-left: 8px" @click="toggleAdvanced" class="no-border-button toggle-button">
                        {{ advanced ? '收起' : '展开' }}
                        <UpOutlined v-if="advanced" />
                        <DownOutlined v-else />
                      </a-button>
                    </span>
                  </a-form-item>
                </a-col>
              </template>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operations">
          <a-button type="text" shape="circle" @click="getList" class="refresh-icon-button">
            <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
          </a-button>
          <a-button
            type="primary"
            @click="$refs.createForm.handleAdd()"
            v-hasPermi="['system:user:add']"
            class="add-button"
          >
            <PlusOutlined />新增
          </a-button>
          <a-button @click="handleExport" v-hasPermi="['system:user:export']" class="no-border-button export-button">
            <UploadOutlined />导出
          </a-button>
          <a-button
            @click="$refs.importExcel.importExcelHandleOpen()"
            v-hasPermi="['system:user:import']"
            class="no-border-button import-button"
          >
            <DownloadOutlined />导入
          </a-button>

          <a-button
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['system:user:remove']"
            class="no-border-button"
          >
            <DeleteOutlined />删除
          </a-button>

          <a-button
            :disabled="multiple"
            @click="handleProjectAuth"
            v-hasPermi="['system:user:projectAuthorization']"
            class="no-border-button"
          >
            <SwapOutlined />项目授权
          </a-button>

          <a-button
            :disabled="multiple"
            @click="handleEditStatus"
            v-hasPermi="['system:user:status']"
            class="no-border-button"
          >
            <EditOutlined />修改状态
          </a-button>

          <a-button
            @click="handleDownloadTemplate"
            v-hasPermi="['system:user:importTemplate']"
            class="no-border-button template-download-button"
          >
            <CloudDownloadOutlined />导入模板下载
          </a-button>

          <!-- <table-setting
              :style="{ float: 'right' }"
              v-model:table-size="tableSize"
              v-model:value="columns"
              :refresh-loading="loading"
              @refresh="getList"
            /> -->
        </div>
        <!-- 增加修改 -->
        <!-- 创建/编辑用户,单独封装了组件 -->
        <create-form
          ref="createForm"
          :sexOptions="dict.type['sys_user_sex']"
          :currentStatusOptions="dict.type['current_status']"
          :loginPlatformOptions="dict.type['user_authorized_platform']"
          :deptOptions="deptOptions"
          @ok="getList"
          @close="getList"
          @select-tree="getTreeselect"
        />
        <!-- 修改密码抽屉 -->
        <reset-password ref="resetPassword" />
        <!-- 分配角色模态框 -->
        <auth-role ref="authRole" />
        <!-- 上传文件 -->
        <import-excel ref="importExcel" @ok="getList" />
        <!-- 员工日志组件 -->
        <employee-log
          :visible="employeeLogModalVisible"
          :userId="currentUserId"
          :userName="currentUserName"
          permissionPrefix="system:user"
          @close="handleCloseEmployeeLog"
        />
        <!-- 修改状态弹窗组件 -->
        <edit-status-modal
          :visible="statusModalVisible"
          :statusOptions="dict.type['current_status']"
          @confirm="handleConfirmEditStatus"
          @cancel="handleCancelEditStatus"
        />
        <!-- 证书预览组件 -->
        <certificate-preview
          :visible="certificatePreviewVisible"
          :certificateUrl="currentCertificateUrl"
          @close="handleCloseCertificatePreview"
        />
        <!-- 项目授权弹窗 -->
        <a-modal
          title="项目授权"
          :visible="projectAuthModalVisible"
          @ok="confirmProjectAuth"
          @cancel="cancelProjectAuth"
          :maskClosable="false"
        >
          <a-form-item label="选择项目">
            <a-select
              :value="isAllProjectSelected ? '0' : selectedProjects"
              placeholder="请选择项目"
              style="width: 100%"
              :mode="isAllProjectSelected ? undefined : 'multiple'"
              @change="handleProjectChange"
            >
              <a-select-option value="0">全部项目</a-select-option>
              <a-select-option v-for="project in projectList" :key="project.id" :value="project.id">
                {{ project.chineseName || project.projectCode }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-modal>
        <!-- 数据表格 -->
        <div style="margin-top: 20px">
          <a-table
            :loading="loading"
            :size="tableSize"
            rowKey="id"
            :columns="tableColumns"
            :data-source="list"
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
            }"
            :pagination="false"
            :bordered="tableBordered"
            :scroll="{ x: 'max-content' }"
            class="optimized-table"
          >
            <template #bodyCell="{ column, text, record, index }">
              <!-- 序号列 -->
              <template v-if="column.dataIndex === 'id'">
                <span>{{
                  (queryParam.pageNum - 1) * queryParam.pageSize +
                  (index !== undefined && index !== null ? index : list.findIndex((item) => item.id === record.id)) +
                  1
                }}</span>
              </template>
              <!-- 入职日期 -->
              <template v-else-if="column.dataIndex === 'entryTime'">
                {{ formatDate(record.entryTime) }}
              </template>
              <!-- 离职日期 -->
              <template v-else-if="column.dataIndex === 'departTime'">
                {{ formatDate(record.departTime) }}
              </template>
              <!-- 当前状态 -->
              <template v-else-if="column.dataIndex === 'userStatus'">
                {{ getDictLabel(dict.type['current_status'], record.userStatus) }}
              </template>
              <!-- 用户授权平台 -->
              <template v-else-if="column.dataIndex === 'loginPlatform'">
                {{ getDictLabel(dict.type['user_authorized_platform'], record.loginPlatform) }}
              </template>
              <!-- 操作列 -->
              <template v-else-if="column.dataIndex === 'operation'">
                <div v-if="record.id !== 1" class="table-action-buttons">
                  <a
                    v-if="record.certificateUrl"
                    @click.stop="handlePreviewCertificate(record)"
                    style="cursor: pointer"
                  >
                    证书
                  </a>
                  <span v-if="record.certificateUrl" class="action-divider">|</span>

                  <a
                    @click="handleViewEmployeeLog(record)"
                    v-hasPermi="['system:user:employeeLog']"
                    class="employee-log-link"
                  >
                    员工日志
                  </a>
                  <span class="action-divider">|</span>

                  <a
                    @click="$refs.createForm.handleUpdate(record, undefined)"
                    v-hasPermi="['system:user:edit']"
                    class="edit-link"
                  >
                    编辑
                  </a>
                  <span class="action-divider" v-hasPermi="['system:user:remove']">|</span>

                  <a @click="handleDelete(record)" v-hasPermi="['system:user:remove']" class="delete-link"> 删除 </a>
                </div>
              </template>
              <!-- 其他字段：默认显示 text 值 -->
              <template v-else>
                <span>{{ text }}</span>
              </template>
            </template>
          </a-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrapper">
          <div class="pagination-left">
            <span class="pagination-info">
              显示第 {{ (queryParam.pageNum - 1) * queryParam.pageSize + 1 }} 到第
              {{ Math.min(queryParam.pageNum * queryParam.pageSize, total) }} 条数据/共 {{ total }} 条
            </span>
            <a-select
              v-model:value="queryParam.pageSize"
              style="width: 100px; margin-left: 8px"
              @change="onShowSizeChange(queryParam.pageNum, queryParam.pageSize)"
              class="no-border-radius-select"
            >
              <a-select-option :value="10">10条/页</a-select-option>
              <a-select-option :value="20">20条/页</a-select-option>
              <a-select-option :value="50">50条/页</a-select-option>
              <a-select-option :value="100">100条/页</a-select-option>
            </a-select>
          </div>
          <div class="pagination-right">
            <a-pagination
              :current="queryParam.pageNum"
              :total="total"
              :page-size="queryParam.pageSize"
              :show-total="false"
              @change="changeSize"
            />
            <span class="pagination-jump">
              到第
              <a-input-number
                v-model:value="jumpPage"
                :min="1"
                :max="Math.ceil(total / queryParam.pageSize)"
                style="width: 60px; margin: 0 4px"
                @pressEnter="handleJumpPage"
                class="no-border-radius-input-number"
              />
              页
            </span>
          </div>
        </div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import {
  pageUser,
  delUser,
  changeUserStatus,
  deptTreeSelect,
  editProjectCodes,
  editUserStatus,
} from '@/api/system/user'
import { listRole } from '@/api/system/role'
import {
  SearchOutlined,
  RedoOutlined,
  UpOutlined,
  DownOutlined,
  PlusOutlined,
  DownloadOutlined,
  UploadOutlined,
  DeleteOutlined,
  SwapOutlined,
  EditOutlined,
  CloudDownloadOutlined,
} from '@ant-design/icons-vue'
import { listProjectInfo } from '@/api/user/projectInfo'
import AuthRole from './modules/AuthRole'
import ResetPassword from './modules/ResetPassword'
import CreateForm from './modules/CreateForm'
import ImportExcel from './modules/ImportExcel'
import DeptTree from './modules/DeptTree'
import EmployeeLog from './modules/EmployeeLog'
import CertificatePreview from './modules/CertificatePreview'
import EditStatusModal from './modules/EditStatusModal'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'User',
  components: {
    SearchOutlined,
    RedoOutlined,
    UpOutlined,
    DownOutlined,
    PlusOutlined,
    DownloadOutlined,
    UploadOutlined,
    DeleteOutlined,
    SwapOutlined,
    EditOutlined,
    CloudDownloadOutlined,
    AuthRole,
    ResetPassword,
    CreateForm,
    ImportExcel,
    DeptTree,
    EmployeeLog,
    CertificatePreview,
    EditStatusModal,
  },
  mixins: [tableMixin],
  dicts: ['user_authorized_platform', 'sys_normal_disable', 'current_status', 'sys_user_sex'],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 部门树选项
      deptOptions: [
        {
          id: 0,
          label: '',
          children: [],
        },
      ],
      // 日期范围
      dateRange: [],
      roleOptions: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        nickName: undefined,
        postName: undefined,
        roleId: undefined,
        nationality: undefined,
        projectId: undefined,
        projectCodes: undefined,
        wristbandMac: undefined,
        userName: undefined,
        phoneNumber: undefined,
        status: undefined,
        userStatus: undefined,
        loginPlatform: undefined,
        deptId: undefined,
        birthDateBegin: undefined,
        birthDateEnd: undefined,
        entryTimeBegin: undefined,
        entryTimeEnd: undefined,
        departTimeBegin: undefined,
        departTimeEnd: undefined,
      },
      // 分页跳转
      jumpPage: 1,
      // 修改状态弹窗
      statusModalVisible: false,
      // 项目授权弹窗
      projectAuthModalVisible: false,
      selectedProjects: [],
      projectList: [],
      isAllProjectSelected: false,
      // 证书预览弹窗
      certificatePreviewVisible: false,
      currentCertificateUrl: '',
      // 员工日志弹窗
      employeeLogModalVisible: false,
      currentUserId: null,
      currentUserName: '',
      columns: [
        {
          title: '员工姓名',
          dataIndex: 'nickName',
          align: 'center',
        },

        {
          title: '岗位名称',
          dataIndex: 'postName',
          align: 'center',
        },

        {
          title: '员工角色',
          dataIndex: 'roleName',
          align: 'center',
        },

        {
          title: '民族',
          dataIndex: 'nationality',
          align: 'center',
        },

        {
          title: '出生年月日',
          dataIndex: 'birthDate',
          align: 'center',
        },

        {
          title: '入职日期',
          dataIndex: 'entryTime',
          align: 'center',
        },

        {
          title: '所在项目',
          dataIndex: 'chineseName',
          align: 'center',
        },

        {
          title: '离职日期',
          dataIndex: 'departTime',
          align: 'center',
        },

        {
          title: '当前状态',
          dataIndex: 'userStatus',
          align: 'center',
        },

        {
          title: '用户手机号',
          dataIndex: 'phoneNumber',
          align: 'center',
        },
        // {
        //   title: '部门',
        //   dataIndex: 'dept.deptName',
        //   scopedSlots: { customRender: 'dept.deptName' },
        //   align: 'center'
        // },
        {
          title: '用户登录名',
          dataIndex: 'userName',
          align: 'center',
        },
        // {
        //   title: '用户密码',
        //   dataIndex: 'password',
        //   align: 'center',
        // },
        {
          title: '手环mac',
          dataIndex: 'wristbandMac',
          align: 'center',
        },
        {
          title: '用户授权平台',
          dataIndex: 'loginPlatform',
          align: 'center',
        },

        {
          title: '项目授权',
          dataIndex: 'projectCodesName',
          align: 'center',
        },
        // {
        //   title: '状态',
        //   dataIndex: 'status',
        //   scopedSlots: { customRender: 'status' },
        //   align: 'center'
        // },
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 300,
          fixed: 'right',
          align: 'center',
        },
      ],
    }
  },
  created() {
    this.getList()
    this.getDeptTree()
    this.getProjectList()
    this.getRoleOptions()
  },
  computed: {
    birthDateRange: {
      get() {
        const begin = this.queryParam.birthDateBegin
        const end = this.queryParam.birthDateEnd
        return begin && end ? [begin, end] : []
      },
      set(val) {
        const begin = Array.isArray(val) && val.length > 0 ? val[0] : undefined
        const end = Array.isArray(val) && val.length > 1 ? val[1] : undefined
        this.queryParam.birthDateBegin = begin || undefined
        this.queryParam.birthDateEnd = end || undefined
      },
    },
    entryTimeRange: {
      get() {
        const begin = this.queryParam.entryTimeBegin
        const end = this.queryParam.entryTimeEnd
        return begin && end ? [begin, end] : []
      },
      set(val) {
        const begin = Array.isArray(val) && val.length > 0 ? val[0] : undefined
        const end = Array.isArray(val) && val.length > 1 ? val[1] : undefined
        this.queryParam.entryTimeBegin = begin || undefined
        this.queryParam.entryTimeEnd = end || undefined
      },
    },
    departTimeRange: {
      get() {
        const begin = this.queryParam.departTimeBegin
        const end = this.queryParam.departTimeEnd
        return begin && end ? [begin, end] : []
      },
      set(val) {
        const begin = Array.isArray(val) && val.length > 0 ? val[0] : undefined
        const end = Array.isArray(val) && val.length > 1 ? val[1] : undefined
        this.queryParam.departTimeBegin = begin || undefined
        this.queryParam.departTimeEnd = end || undefined
      },
    },
    submitButtonStyle() {
      return this.advanced ? { float: 'left', overflow: 'hidden' } : {}
    },
    // 表格列配置（使用 computed 以便在 customRender 中访问 this）
    tableColumns() {
      const that = this
      return [
        {
          title: '序号',
          dataIndex: 'id',
          width: 80,
          align: 'center',
          customRender: ({ index }) => {
            const pageNum = that.queryParam.pageNum || 1
            const pageSize = that.queryParam.pageSize || 10
            const currentIndex = index !== undefined && index !== null ? Number(index) : 0
            if (isNaN(currentIndex) || isNaN(pageNum) || isNaN(pageSize)) {
              return currentIndex + 1
            }
            return (pageNum - 1) * pageSize + currentIndex + 1
          },
        },
        ...this.columns, // 保留其他列配置
      ]
    },
  },
  watch: {},
  methods: {
    /**
     * 获取字典标签
     * @param {Array} dictList 字典列表
     * @param {String|Number} value 字典值
     * @returns {String} 字典文字
     */
    formatDate(val) {
      if (val == null || val === '') {
        return ''
      }
      if (typeof val === 'string') {
        return val.length >= 10 ? val.substring(0, 10) : val
      }
      if (Array.isArray(val) && val.length >= 3) {
        const month = String(val[1]).padStart(2, '0')
        const day = String(val[2]).padStart(2, '0')
        return `${val[0]}-${month}-${day}`
      }
      return String(val)
    },
    getDictLabel(dictList, value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      if (!dictList || !Array.isArray(dictList) || dictList.length === 0) {
        return String(value)
      }

      // 将值转换为数字和字符串两种形式进行匹配
      const valueNum = typeof value === 'number' ? value : Number(value)
      const valueStr = String(value)
      const isValueNumeric = !isNaN(valueNum) && valueNum !== null

      // 查找匹配的字典项
      const dictItem = dictList.find((item) => {
        if (!item || item.value === undefined || item.value === null) {
          return false
        }
        const itemValue = item.value
        const itemValueNum = typeof itemValue === 'number' ? itemValue : Number(itemValue)
        const itemValueStr = String(itemValue)
        const isItemNumeric = !isNaN(itemValueNum) && itemValueNum !== null

        // 1. 严格相等匹配
        if (itemValue === value) {
          return true
        }
        // 2. 字符串匹配
        if (itemValueStr === valueStr) {
          return true
        }
        // 3. 数字匹配（如果都是有效数字）
        if (isValueNumeric && isItemNumeric && itemValueNum === valueNum) {
          return true
        }
        return false
      })

      if (dictItem && dictItem.label) {
        return dictItem.label
      }

      return String(value)
    },
    changeSwitch(e, record) {
      console.log(e)
      this.confirmHandleStatus(record)
    },
    getTreeselect() {},
    /** 查询用户列表 */
    getList() {
      this.loading = true
      pageUser(this.addDateRange(this.queryParam, this.dateRange)).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.jumpPage = this.queryParam.pageNum
        this.loading = false
      })
    },
    /** 查询部门下拉树结构 */
    getDeptTree() {
      deptTreeSelect().then((response) => {
        this.deptOptions = response.data
      })
    },
    getRoleOptions() {
      listRole()
        .then((response) => {
          const list = response && response.data ? response.data : []
          this.roleOptions = Array.isArray(list) ? list : []
        })
        .catch(() => {
          this.roleOptions = []
        })
    },
    filterRoleOption(input, option) {
      if (!input) {
        return true
      }
      const value = option && option.value
      const role = this.roleOptions.find((item) => String(item.id) === String(value))
      const text = role ? role.roleName || '' : ''
      return text.toLowerCase().includes(String(input).toLowerCase().trim())
    },
    filterProjectOption(input, option) {
      if (!input) {
        return true
      }
      const value = option && option.value
      if (String(value) === '0') {
        return '全部项目'.includes(String(input).trim())
      }
      const project = this.projectList.find((item) => String(item.id) === String(value))
      const text = project ? `${project.chineseName || ''} ${project.projectCode || ''}` : ''
      return text.toLowerCase().includes(String(input).toLowerCase().trim())
    },
    buildQueryParam(overrides = {}) {
      return {
        pageNum: 1,
        pageSize: 10,
        nickName: undefined,
        postName: undefined,
        roleId: undefined,
        nationality: undefined,
        projectId: undefined,
        projectCodes: undefined,
        wristbandMac: undefined,
        userName: undefined,
        phoneNumber: undefined,
        status: undefined,
        userStatus: undefined,
        loginPlatform: undefined,
        deptId: undefined,
        birthDateBegin: undefined,
        birthDateEnd: undefined,
        entryTimeBegin: undefined,
        entryTimeEnd: undefined,
        departTimeBegin: undefined,
        departTimeEnd: undefined,
        ...overrides,
      }
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.queryParam = this.buildQueryParam({
        pageSize: this.queryParam.pageSize || 10,
      })
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.queryParam.pageNum = 1
      this.jumpPage = 1
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.jumpPage = current
      this.getList()
    },
    handleJumpPage() {
      if (this.jumpPage && this.jumpPage >= 1) {
        const maxPage = Math.ceil(this.total / this.queryParam.pageSize)
        if (this.jumpPage > maxPage) {
          this.jumpPage = maxPage
        }
        this.queryParam.pageNum = this.jumpPage
        this.getList()
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    clickDeptNode(deptId) {
      this.queryParam.deptId = deptId
      this.handleQuery()
    },
    /* 用户状态修改 status 0开启 1关闭*/
    confirmHandleStatus(row) {
      const oldStatus = row.status
      const text = row.status === 0 ? '启用' : '关闭'
      const status = row.status === 1 ? 0 : 1
      changeUserStatus(row.id, status)
        .then((res) => {
          if (res.success) {
            row.status = status
            this.$message.success(text + '成功', 3)
          } else {
            row.status = oldStatus
            this.$message.error(`${text}失败, ${res.message}`, 3)
          }
        })
        .catch(() => {
          this.$message.error(text + '异常', 3)
        })
    },
    cancelHandleStatus(row) {},

    /** 获取项目列表 */
    getProjectList() {
      listProjectInfo({})
        .then((response) => {
          this.projectList = response.data || []
        })
        .catch(() => {
          this.projectList = []
        })
    },
    /** 打开项目授权弹窗 */
    handleProjectAuth() {
      if (this.ids.length === 0) {
        this.$message.warning('请先选择要授权的用户', 3)
        return
      }
      // 检查选中的用户是否都是管理层或营运经理
      const invalidUsers = []
      this.selectedRows.forEach((user) => {
        const roleName = user.roleName || ''
        if (roleName !== '管理层' && roleName !== '营运经理') {
          invalidUsers.push(user.nickName || user.userName || '未知用户')
        }
      })
      if (invalidUsers.length > 0) {
        this.$message.warning(
          `项目授权只能对管理层和营运经理进行操作，以下用户不符合要求：${invalidUsers.join('、')}`,
          5
        )
        return
      }
      this.selectedProjects = []
      this.isAllProjectSelected = false
      this.projectAuthModalVisible = true
    },
    /** 处理项目选择变化 */
    handleProjectChange(value) {
      // 如果选择了"全部项目"（值为"0"）
      if (value === '0' || (Array.isArray(value) && value.includes('0'))) {
        this.isAllProjectSelected = true
        this.selectedProjects = []
      } else {
        this.isAllProjectSelected = false
        // 如果是数组，过滤掉"0"和无效值
        if (Array.isArray(value)) {
          this.selectedProjects = value.filter((v) => v !== '0' && v !== undefined && v !== null)
        } else {
          this.selectedProjects = value ? [value] : []
        }
      }
    },
    /** 确认项目授权 */
    confirmProjectAuth() {
      if (!this.isAllProjectSelected && (!this.selectedProjects || this.selectedProjects.length === 0)) {
        this.$message.warning('请选择项目', 3)
        return
      }
      const that = this
      let projectCodes = ''
      if (this.isAllProjectSelected) {
        projectCodes = '0'
      } else {
        projectCodes = this.selectedProjects.join(',')
      }
      editProjectCodes({
        ids: this.ids.join(','),
        projectCodes: projectCodes,
      })
        .then((res) => {
          if (res.success) {
            that.$message.success('项目授权成功', 3)
            that.projectAuthModalVisible = false
            that.selectedProjects = []
            that.isAllProjectSelected = false
            that.onSelectChange([], [])
            that.getList()
          } else {
            that.$message.error(`项目授权失败: ${res.message}`, 3)
          }
        })
        .catch(() => {
          that.$message.error('项目授权异常', 3)
        })
    },
    /** 取消项目授权 */
    cancelProjectAuth() {
      this.projectAuthModalVisible = false
      this.selectedProjects = []
      this.isAllProjectSelected = false
    },
    /** 预览证书图片 */
    handlePreviewCertificate(record) {
      console.log('handlePreviewCertificate called', record)
      if (!record || !record.certificateUrl) {
        this.$message.warning('该用户暂无证书图片', 3)
        return
      }
      console.log('Setting certificate URL:', record.certificateUrl)
      this.currentCertificateUrl = record.certificateUrl
      this.certificatePreviewVisible = true
      console.log('Certificate preview visible:', this.certificatePreviewVisible)
    },
    /** 关闭证书预览 */
    handleCloseCertificatePreview() {
      this.certificatePreviewVisible = false
      this.currentCertificateUrl = ''
    },
    /** 查看员工日志 */
    handleViewEmployeeLog(record) {
      if (!record || !record.id) {
        this.$message.warning('用户信息不完整', 3)
        return
      }
      this.currentUserId = record.id
      this.currentUserName = record.nickName || record.userName || '未知用户'
      this.employeeLogModalVisible = true
    },
    /** 关闭员工日志弹窗 */
    handleCloseEmployeeLog() {
      this.employeeLogModalVisible = false
      this.currentUserId = null
      this.currentUserName = ''
    },
    /** 打开修改状态弹窗 */
    handleEditStatus() {
      if (this.ids.length === 0) {
        this.$message.warning('请先选择要修改状态的用户', 3)
        return
      }
      this.statusModalVisible = true
    },
    /** 确认修改状态 */
    handleConfirmEditStatus(userStatus) {
      const that = this
      editUserStatus({
        ids: this.ids.join(','),
        userStatus: userStatus,
      })
        .then((res) => {
          if (res.success) {
            that.$message.success('修改状态成功', 3)
            that.statusModalVisible = false
            that.onSelectChange([], [])
            that.getList()
          } else {
            that.$message.error(`修改状态失败: ${res.message}`, 3)
          }
        })
        .catch(() => {
          that.$message.error('修改状态异常', 3)
        })
    },
    /** 取消修改状态 */
    handleCancelEditStatus() {
      this.statusModalVisible = false
    },

    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const userIds = row.id || this.ids
      // 获取要删除的员工姓名
      let nickNames = []
      if (row && row.id) {
        // 单条删除
        nickNames = [row.nickName || '未知员工']
      } else {
        // 批量删除
        nickNames = this.selectedRows.map((item) => item.nickName || '未知员工')
      }
      const nickNamesText = nickNames.length > 0 ? nickNames.join('、') : '未知员工'
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中员工姓名为：' + nickNamesText + ' 的数据',
        onOk() {
          return delUser(userIds).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          const params = {
            ...that.queryParam,
          }
          if (that.ids && that.ids.length > 0) {
            params.userIds = that.ids
          }
          that.download('system/user/export', params, `user_${new Date().getTime()}.xlsx`)
        },
        onCancel() {},
      })
    },

    /**
     * 下载导入模板
     */
    handleDownloadTemplate() {
      this.download('system/user/importTemplate', {}, `人员导入模板_${new Date().getTime()}.xlsx`)
    },
  },
}
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 100px;
  min-width: 100px;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 100px;
  text-align: right;
}

/* 搜索栏 FormItem 布局：左侧文字固定 100px，右侧输入区域自适应 */
.table-page-search-wrapper :deep(.ant-form-item) {
  display: flex;
  align-items: center;
  width: 100%;
}

.table-page-search-wrapper :deep(.ant-form-item-label) {
  flex: 0 0 100px;
}

.table-page-search-wrapper :deep(.ant-form-item-control) {
  flex: 1 1 auto;
  margin-left: 8px;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

.no-border-radius-select :deep(.ant-select-selector) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 - 优先级高于 no-border-radius-input */
/* 普通输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input) {
  width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框外层样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
/* 使用更具体的选择器确保覆盖所有情况 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.ant-form-item .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input-content .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper input.ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input[type='text']) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  width: 100% !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

/* 日期选择器样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框容器样式 */
.table-page-search-wrapper :deep(.no-border-radius-select.ant-select),
.table-page-search-wrapper :deep(.ant-select) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
}

.table-page-search-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

/* 移除搜索栏输入框、下拉选择框、日期选择框聚焦时的高亮效果 */
/* 输入框聚焦样式 - 内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-focused) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 带前缀/后缀的输入框聚焦样式 - 外部容器保持边框，内部input隐藏边框，聚焦时不显示高亮 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 聚焦时，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 下拉选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector:focus),
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-focused .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector:focus),
.table-page-search-wrapper :deep(.ant-select-focused .ant-select-selector) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker:focus),
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker-focused),
.table-page-search-wrapper :deep(.ant-picker:focus),
.table-page-search-wrapper :deep(.ant-picker-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 搜索区域数字输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input-number.ant-input-number),
.table-page-search-wrapper :deep(.no-border-radius-input-number) {
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

/* 按钮区域样式 */
.table-page-search-submitButtons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

.no-border-button[disabled] {
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed !important;
}

.no-border-button[disabled]:hover,
.no-border-button[disabled]:focus {
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed !important;
}

/* 重置按钮样式 */
.reset-button {
  background: #f3f3f3 !important;
  color: #101010 !important;
}

.reset-button:hover,
.reset-button:focus {
  background: #f3f3f3 !important;
  color: #101010 !important;
}

/* 展开/收起按钮文字和图标颜色，去掉底部阴影 */
.toggle-button {
  color: #165dff !important;
  background-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;
}

.toggle-button :deep(.anticon) {
  color: #165dff !important;
}

.toggle-button:hover,
.toggle-button:focus {
  color: #165dff !important;
  background-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165dff !important;
}

/* 导入导出按钮背景颜色 */
.import-button,
.export-button {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-button :deep(.anticon),
.export-button :deep(.anticon) {
  color: #333 !important;
}

.import-button:hover,
.export-button:hover {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-button:hover :deep(.anticon),
.export-button:hover :deep(.anticon) {
  color: #333 !important;
}

.import-button:focus,
.export-button:focus {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-button:focus :deep(.anticon),
.export-button:focus :deep(.anticon) {
  color: #333 !important;
}

/* 导入模板下载按钮文字和图标颜色，去掉底部阴影 */
.template-download-button {
  color: #165dff !important;
  background-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;
}

.template-download-button :deep(.anticon) {
  color: #165dff !important;
}

.template-download-button:hover,
.template-download-button:focus {
  color: #165dff !important;
  background-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;
}

.template-download-button:hover :deep(.anticon),
.template-download-button:focus :deep(.anticon) {
  color: #165dff !important;
}

.table-action-buttons a {
  color: #1890ff;
  cursor: pointer;
  white-space: nowrap; /* 防止操作按钮换行 */
}

.table-action-buttons a:hover {
  color: #40a9ff;
}

/* 编辑按钮颜色 */
.table-action-buttons .edit-link {
  color: #165dff !important;
}

.table-action-buttons .edit-link:hover {
  color: #4080ff !important;
}

/* 删除按钮颜色 */
.table-action-buttons .delete-link {
  color: #ff4d4f !important;
}

.table-action-buttons .delete-link:hover {
  color: #ff7875 !important;
}

/* 员工日志按钮颜色 */
.table-action-buttons .employee-log-link {
  color: #ffa759 !important;
}

.table-action-buttons .employee-log-link:hover {
  color: #ffb877 !important;
}

.action-divider {
  margin: 0 8px;
  color: #d9d9d9;
  white-space: nowrap;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap; /* 表头不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap; /* 表格内容不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px; /* 增加内边距 */
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 操作列固定右侧样式 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child) {
  position: sticky;
  right: 0;
  background: white;
  z-index: 1;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-thead > tr > th:last-child) {
  position: sticky;
  right: 0;
  background: #fafafa;
  z-index: 2;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #ffffff !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 分页组件样式 - 去掉圆角 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 分页选中页数样式 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #ffffff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165dff !important;
  border-color: #165dff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #ffffff !important;
}
</style>
